import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class ConfirmModalComponent {
  @Input() message = 'Sei sicuro di voler procedere?';
  @Input() title = 'Richiesta conferma';
  @Input() nextBtn = 'Elimina';
  @Input() cancelBtn = 'Annulla';
  @Input() classConfirmBtn = 'btn-cancel';
  @Input() classCancelBtn = 'btn-outline';

  constructor(public activeModal: NgbActiveModal) {}
}
